import * as types from '../actions/types';
import _ from 'lodash';

const initialRest = {
  'counties': [],
  'errors': [],
  'quote': {}
};

let newState = null;// this is used in places where we don't want to merge the state outright

const restReducer = (state = initialRest, action) => {
  switch (action.type) {
    case types.FAIL_REST_REQUEST:
      const errors = _.clone(state.errors);
      errors.push(action.response);
      console.error(action.response);
      return _.merge({}, state, { errors });

    case types.FETCH_COUNTIES:
      const counties = action.response.data;
      return _.merge({}, state, { counties });

    case types.SET_RESULTS:
      let quote = _.clone(action.response.data);

      for (let k in quote) if (quote.hasOwnProperty(k) && _.isNull(quote[k])) delete quote[k];

      if (quote.Plans) {
        quote.selectedPlan = quote.Plans.find(function (obj) { return obj.PlanId === quote.SelectedPlanId; });
        quote.planOrderPremium = quote.Plans.slice().sort(function (obj1, obj2) { return obj1.MonthlyIndividualPremium - obj2.MonthlyIndividualPremium; });
        quote.planOrderDeductible = quote.Plans.slice().sort(function (obj1, obj2) { return obj1.IndividualDeductible - obj2.IndividualDeductible; });
        quote.planOrderMax = quote.Plans.slice().sort(function (obj1, obj2) { return obj1.IndividualOopMax - obj2.IndividualOopMax; });

        switch (quote.selectedPlan.MetalLevel) {
          case 1:
            quote.MetalLevel = 'Bronze';
            break;
          case 2:
            quote.MetalLevel = 'Silver';
            break;
          case 3:
            quote.MetalLevel = 'Gold';
            break;
          case 4:
            quote.MetalLevel = 'Platinum';
            break;
          default:
            quote.MetalLevel = 'Bronze';
            break;
        }
        quote.deductibleType = quote.selectedPlan.HasDeductible ? 'Yes' : 'No';
      }

      if (quote.hasOwnProperty('FamilyType')) quote.familyTypeQuote = quote.FamilyType;

      return _.merge({}, state, { quote });

    case types.RESET_QUOTE:
      newState = _.clone(state);
      for (let k in state.quote) delete state.quote[k];
      return newState;

    case types.CHANGE_SELECTED_PLAN:
      newState = _.clone(state);
      newState.quote.selectedPlan = action.planObj;
      newState.quote.SelectedPlanId = action.planId;
      return newState;

    default:
      return state;
  }
};

export default restReducer;
